'use strict'

var SLICE = Array.prototype.slice
var lockArgsArray = require('./lockArgsArray')

module.exports = function(fn){
    return lockArgsArray(fn, SLICE.call(arguments, 1))
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/functionally/src/lockArgs.js
 ** module id = 843
 ** module chunks = 0
 **/